import {Injectable, Component, OnInit, AfterViewInit} from '@angular/core';
import {ScrollPositionService} from '../../services/scroll-position.service';

declare let AOS: any;

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit, AfterViewInit {

  constructor(private spService: ScrollPositionService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    AOS.refreshHard();
    this.spService.autoScroll();
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/services/services.component.ts